import React from 'react';
import { IMAGE } from '@yme/atoms/gallery/constants';
import { Image } from '@yme/atoms/image';
export function isExperienceDetailsCardEmpty(props) {
    return !props.cqType;
}
export const prepareGalleryData = (images = []) => {
    const imageComponents = images.map((image) => ({
        element: (React.createElement(Image, { key: image?.src, ...image })),
        id: image?.src,
        type: IMAGE,
    }));
    return {
        imagesList: imageComponents,
        thumbnailsList: imageComponents,
    };
};
